import { messageTypes } from '../types';

const initialState = {
    loading: false,
    queue: [],
    error: null,
};

export const message = (state = initialState, action) => {
    switch (action.type) {
        case messageTypes.MESSAGE_REQUEST:
            return { ...state, loading: true };
        case messageTypes.MESSAGE_VIEW_ERROR:
            return { ...state, loading: false, error: action.error };
        case messageTypes.MESSAGE_CLEAR:
            return {
                queue: state.queue.filter((msg) => msg.messageId !== action.messageId),
            };
        case messageTypes.MESSAGE_SHOW:
            return {
                queue: [
                    ...state.queue,
                    {
                        messageId: Date.now(),
                        ...action,
                    },
                ],
            };

        default:
            return state;
    }
};
